import { render, staticRenderFns } from "./ArticleStatic.vue?vue&type=template&id=6540e23e"
import script from "./ArticleStatic.vue?vue&type=script&lang=js"
export * from "./ArticleStatic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports